import { AppFlowMetadata, type AppFlowMetadataScope } from '@src/hooks/flow/useFlowConfigs';
import { APP_FLOW_SCOPE_VIEW_ID_MAP } from '../constants';

export function getAppFlowViewId(
  dimension: string | string[] | undefined,
  filter: Array<
    Array<{
      field: string;
      op: string;
      value: string | number;
    }>
  >,
  flowConfig?: AppFlowMetadata,
) {
  if (!flowConfig) return undefined;

  const queryDimensions = (Array.isArray(dimension) ? dimension : [dimension]).filter(
    Boolean,
  ) as string[];

  const dimensionScopes = queryDimensions
    .map((item) => flowConfig.metaDefinition.dimensions.find((it) => it.identifier === item)?.scope)
    .filter(Boolean) as AppFlowMetadataScope[];

  const filterDimensions = new Set(filter.flat(2).map((it) => it.field));
  const filterDimensionScopes = new Set(
    flowConfig.metaDefinition.dimensions
      .filter((it) => filterDimensions.has(it.identifier))
      .map((it) => it.scope),
  );

  const targetDimensionScope = dimensionScopes.find((it) => it === 'error' || it === 'service');

  if (targetDimensionScope) {
    return APP_FLOW_SCOPE_VIEW_ID_MAP[targetDimensionScope];
  }

  // Check the filter rules, and find the first scope that is either 'error' or 'service'
  const filterTargetScope = Array.from(filterDimensionScopes).find(
    (it) => it === 'error' || it === 'service',
  );

  if (filterTargetScope) return APP_FLOW_SCOPE_VIEW_ID_MAP[filterTargetScope];

  return undefined;
}
